export default __webpack_public_path__ + "static/media/graph5.05f04ceb.png";